import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Spin } from "antd";

import NoPictureIcon from "./CustomIcons/merchant-placeholder";

const Wrap = styled.div`
  width: 57px;
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  border: 1px solid #e8e8e8;
  border-radius: 4px;
`;

const LoadingSpin = styled(Spin)`
  display: flex;
  &.ant-spin {
    .ant-spin-dot {
      width: 39px;
      height: 39px;
    }
    .ant-spin-dot-item {
      width: 16px;
      height: 16px;
      background-color: ${({ theme }) => theme.palette.accent};
    }
  }
`;

const CartImage = ({ merchantName, merchantLogo }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <Wrap>
      {loading && !error && <LoadingSpin size="large" />}
      {!error ? (
        <Image
          src={merchantLogo}
          alt={`${merchantName} logo`}
          onError={() => setError(true)}
          onLoad={() => setLoading(false)}
          hidden={loading}
          style={{ width: "100%", height: "100%" }}
        />
      ) : (
        <NoPictureIcon />
      )}
    </Wrap>
  );
};

CartImage.propTypes = {
  merchantName: PropTypes.string.isRequired,
  merchantLogo: PropTypes.string,
};

CartImage.defaultProps = {
  merchantLogo: "",
};

export default CartImage;
